import { forwardRef } from "react";
import { OTPInput } from "input-otp";
import { cn } from "@/lib/cn";

type Props = {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  autoFocus?: boolean;
  inputMode?: "numeric" | "text";
  className?: string;
  disabled?: boolean;
};

export const OtpInput = forwardRef<HTMLInputElement, Props>(
  ({ maxLength = 6, className, ...props }, ref) => {
    return (
      <OTPInput
        ref={ref}
        maxLength={maxLength}
        containerClassName={cn("flex items-center gap-2", className)}
        render={({ slots }) => (
          <div className="flex w-full justify-between gap-2">
            {slots.map((slot, idx) => (
              <div
                key={idx}
                className={cn(
                  "relative grid h-12 w-12 place-items-center rounded-lg border text-lg font-semibold",
                  "transition-[border-color,box-shadow] duration-150",
                  slot.isActive
                    ? "border-brand ring-2 ring-ring/40"
                    : "border-border hover:border-border-strong",
                  "bg-surface dark:bg-surface-2",
                )}
              >
                {slot.char ?? (slot.isActive ? <span className="h-5 w-px bg-brand animate-pulse" /> : null)}
              </div>
            ))}
          </div>
        )}
        {...props}
      />
    );
  },
);
OtpInput.displayName = "OtpInput";
